// File: InstituteDashboard.js
import React, { useState, useEffect } from 'react';
import InstituteStatCard from '../../components/institute/dashboard/InstituteStatCard';
import InstituteProgramChart from '../../components/institute/dashboard/InstituteProgramChart';
import InstituteCreditLineChart from '../../components/institute/dashboard/InstituteCreditLineChart';
import InstitutePopularPrograms from '../../components/institute/dashboard/InstitutePopularPrograms';
import InstituteProgramCompletionChart from '../../components/institute/dashboard/InstituteProgramCompletionChart';
// import InstituteStudentProgressTable from '../../components/institute/dashboard/InstituteStudentProgressTable';
// import InstituteTransactionTable from '../../components/institute/dashboard/InstituteTransactionTable';
// import InstitutePlacementInsights from '../../components/institute/dashboard/InstitutePlacementInsights';
// import InstitutePlacementMap from '../../components/institute/dashboard/InstitutePlacementMap';
// import InstitutePlacementTimeline from '../../components/institute/dashboard/InstitutePlacementTimeline';
import PageHeader from '../../components/PageHeader';
import { useNavigate } from 'react-router-dom';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { isMobile } from 'react-device-detect';
import LearningJourneyCard from "../../components/LearningJourneyCard";

const InstituteDashboard = () => {
  const navigate = useNavigate();
  const [dashboardData, setDashboardData] = useState({
    totalProgram: 0,
    totalCreditTransacations: 0,
    totalCreditPoints: 0,
    remainingCreditPoints: 0,
    totalStudents: 0,
    totalTeachers: 0,
    programData: [],
    popularPrograms: [],
    creditTransactions: [],
    placementStats: {
      applicationTrends: [],
      programBreakdown: [],
      predictedSuccessRate: 0,
      regions: [],
      events: []
    },
    creditInfo: [],
    totalCredit: 0
  });

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const API_BASE_URL = process.env.REACT_APP_API_LMS;
  const API_TOKEN = process.env.REACT_APP_API_TOKEN;
  const InstituteId = sessionStorage.getItem('id');
  const instituteSrId = sessionStorage.getItem('instituteId');
  const OnlyInstitute = "13";

  // Fetch dashboard data from API
  useEffect(() => {
    const fetchDashboardData = async () => {
      try {
        setLoading(true);
        const response = await fetch(`${API_BASE_URL}/api/institute-dashboard?user_id=${InstituteId}`, {
          method: 'GET',
          headers: {
            'Authorization': API_TOKEN,
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          }
        });

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        // Transform API data to match component expectations
        const transformedData = {
          programStats: data.programStats || [],
          totalCreditPoints: data.totalCredit || 0,
          totalProgram: data?.totalProgram || 0,
          remainingCreditPoints: data.creditBal || 0,
          totalStudents: data.totalStudents || 0,
          totalTeachers: data.totalTeachers || 0,
          programData: data.programData || [],
          totalCreditTransacations: data?.creditTransacations.length || 0,
          popularPrograms: data.studentProgramCount ? data.studentProgramCount.map((program, index) => ({
            id: program.program_id || index + 1,
            name: program.program_title || 'Unknown Program',
            enrollments: program.student_count || 0
          })) : [],
          creditTransactions: data.creditTransacations ? data.creditTransacations.map((transaction, index) => ({
            id: index + 1,
            date: transaction.purchase_date ? new Date(transaction.purchase_date).toISOString().split('T')[0] : new Date().toISOString().split('T')[0],
            type: 'Credit Purchase',
            amount: `${transaction.final_amount || 0}`,
            credits: `+${transaction.credits_purchased || 0}`,
            status: 'completed'
          })) : [],
          creditInfo: data?.creditInfo || [],
          totalCredit: data?.creditInfo?.reduce((sum, p) => sum + p.credit_purchased, 0)
        };

        setDashboardData(transformedData);
        setError(null);
      } catch (err) {
        console.error('Error fetching dashboard data:', err);
        setError('Failed to load dashboard data');
      } finally {
        setLoading(false);
      }
    };

    fetchDashboardData();
  }, []);

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '400px' }}>
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  return (
    <>
      <PageHeader
        title={"Institute Dashboard"}
        breadcrumbs={[]}
      />

      <div className="row mb-6">
        <InstituteStatCard
          title="Total Programs"
          value={dashboardData?.totalProgram?.toLocaleString()}
          icon="bi bi-star-fill"
          onClick={() => navigate('/enroll-program')}
          style={{ cursor: 'pointer' }}
        />
        <InstituteStatCard
          title="Total Enrolled Students"
          value={dashboardData?.totalStudents?.toLocaleString()}
          icon="bi bi-people-fill"
          onClick={() => navigate('/student-enrollment')}
          style={{ cursor: 'pointer' }}
        />
        {/* <InstituteStatCard 
          title="Total Teachers" 
          value={dashboardData.totalTeachers} 
          icon="bi bi-person-circle" 
          style={{ cursor: 'pointer' }}
          /> */}
        <InstituteStatCard
          title="Total License Transacations"
          value={dashboardData.totalCreditTransacations.toLocaleString()}
          icon="bi bi-credit-card"
          onClick={() => navigate('/institute-credits')}
          style={{ cursor: 'pointer' }}
        />
      </div>

      {OnlyInstitute === instituteSrId && (
        <div className="learning-journey-card">
          <LearningJourneyCard />
        </div>
      )}

      <div className="row mb-4">
        <div className="col-12">
          <div className="card blueborder rounded-3">
            <div className="card-header blue-card-header py-3">
              <h5 className="mb-0 newfont d-flex align-items-center">
                <i className="bi bi-graph-up me-2" style={{ color: '#36348E' }}></i>
                License Usage Overview
              </h5>
            </div>
            <div className={isMobile ? "card-body p-2" : "card-body p-4"}>
              <div className="progress mb-4" style={{ height: isMobile ? '25px' : '35px', borderRadius: '10px', backgroundColor: '#CDD4FB' }}>
                {dashboardData?.creditInfo?.map((program, index) => {
                  const { program_title, credit_purchased, credit_balance } = program;
                  const used = credit_purchased - credit_balance;
                  // don't remove the space
                  const tooltipText = `
                                      ${program_title}
                                      Purchased: ${credit_purchased}<br/>
                                      Used: ${used}<br/>
                                      Remaining: ${credit_balance}
                                          `.trim();
                  const colors = ["#297757", "#ffc53a", "#b5322c", "#36348E", "#20c997", "#0d6efd", "#6f42c1", "#fd7e14", "#198754", "#d63384"];
                  const segmentColor = colors[index % colors.length];

                  const renderTooltip = (props) => (
                    <Tooltip id="button-tooltip" className="custom-tooltip text-start" {...props}>
                      <p dangerouslySetInnerHTML={{
                        __html: tooltipText
                      }} />
                    </Tooltip>
                  );
                  return (
                    <OverlayTrigger
                      placement="top"
                      delay={{ show: 250, hide: 400 }}
                      overlay={renderTooltip}
                    >
                      <div
                        key={index}
                        className="progress-bar"
                        style={{
                          width: `${(credit_purchased / dashboardData.totalCredit) * 100}%`,
                          backgroundColor: segmentColor,
                          transition: 'width 1s ease-in-out',
                          cursor: 'pointer',
                        }}
                        role="progressbar"
                      />
                    </OverlayTrigger>
                  );
                })}
              </div>

              <div className="row g-3 px-2">
                {dashboardData?.creditInfo?.map((program, index) => {
                  const { program_title, credit_purchased, credit_balance } = program;
                  const used = credit_purchased - credit_balance;
                  const colors = ["#297757", "#ffc53a", "#b5322c", "#36348E", "#20c997", "#0d6efd", "#6f42c1", "#fd7e14", "#198754", "#d63384"];
                  const color = colors[index % colors.length];

                  return (
                    <div
                      key={index}
                      className="col-12 col-sm-6 col-md-4 d-flex align-items-start"
                    >
                      <i className="bi bi-circle-fill me-2 mt-1" style={{ color }}></i>
                      <div>
                        <div className="fw-semibold">{program_title}</div>
                        <small className="text-muted">
                          {credit_balance} remaining, {used} used
                        </small>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="row mb-4">
        <div className="col-lg-7 mb-4">
          {/* <div className="card h-100 yellowborder rounded-3">
            <div className="card-header yellow-card-header bg-white border-bottom-0 py-3">

              <h6 className="mb-0 newfont d-flex align-items-center">
                <i className="bi bi-pie-chart-fill me-2 text-primary"></i>
                Program Wise Student Distribution
              </h6>
            </div>
            <div className="card-body justify-content-center align-items-center p-0">
              <div className="chart-container" style={{ height: isMobile ? '190px' : '250px', width: '100%' }}>
                <InstituteProgramChart data={dashboardData.programData} />
              </div>
            </div>
          </div> */}
          <div className="card blueborder rounded-3">
            <div className="card-header blue-card-header bg-white border-bottom-0 py-3">
              <h5 className="mb-0 newfont d-flex align-items-center">
                <i className="bi bi-bar-chart-fill me-2 text-primary"></i>
                Program Completion Statistics
              </h5>
            </div>
            <div className="card-body p-4">
              <InstituteProgramCompletionChart stats={dashboardData.programStats} />
            </div>
          </div>
        </div>
        <div className="col-lg-5 mb-4">
          <div className="card yellowborder rounded-3">
            <div className="card-header yellow-card-header bg-white border-bottom-0 py-3">
              <h5 className="mb-0 newfont d-flex align-items-center">
                <i className="bi bi-currency-exchange me-2 text-primary"></i>
                Year Wise Amount Paid
              </h5>
            </div>
            <div className="card-body">
              <div className="chart-container" style={{ height: '305px', width: '100%' }}>
                <InstituteCreditLineChart data={dashboardData?.creditTransactions} />
              </div>
            </div>
            <div className="card-footer bg-white border-top-0 py-3">
              <div className="d-flex justify-content-end align-items-center px-3">
                <button
                  onClick={() => navigate('/institute-credits', { replace: true })}
                  className="btn btn-primary btn-sm px-2 py-1 d-flex align-items-center"
                >
                  <span>View Detail</span>
                  <i className="bi bi-arrow-right ms-2"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="row mb-4">
        <div className="col-12">
          <div className="card blueborder rounded-3">
            <div className="card-header blue-card-header bg-white border-bottom-0 py-3">

              <h5 className="mb-0 newfont d-flex align-items-center">
                <i className="bi bi-journal-bookmark-fill me-2 text-primary"></i>
                Program Wise Student Enrollment
              </h5>
            </div>
            <div className="card-body p-4">
              <InstitutePopularPrograms programs={dashboardData.popularPrograms} />
            </div>
            <div className="card-footer bg-white border-top-0 py-3">
              <div className="d-flex justify-content-end align-items-center px-3">
                <button
                  onClick={() => navigate('/student-enrollment', { replace: true })}
                  className="btn btn-primary btn-sm px-2 py-1 d-flex align-items-center"
                >
                  <span>View All Enrolled Students</span>
                  <i className="bi bi-arrow-right ms-2"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* <div className="row mb-4">
        <div className="col-12">
          <div className="card blueborder rounded-3">
            <div className="card-header blue-card-header bg-white border-bottom-0 py-3">
              <h5 className="mb-0 newfont d-flex align-items-center">
                <i className="bi bi-bar-chart-fill me-2 text-primary"></i>
                Program Completion Statistics
              </h5>
            </div>
            <div className="card-body p-4">
              <InstituteProgramCompletionChart stats={dashboardData.programStats} />
            </div>
          </div>
        </div>
      </div> */}

      {/* <div className="row mb-4">
        <div className="col-12">
          <div className="card yellowborder rounded-3 hover-lift">
            <div className="card-header yellow-card-header bg-white border-bottom-0 py-3 d-flex justify-content-between align-items-center">
              <h5 className="mb-0 d-flex newfont align-items-center">
                <i className="bi bi-bar-chart-fill me-2 text-primary"></i>
                Student Progress Summary
              </h5>
            </div>
            <div className="card-body p-4">
              <div className="table-responsive">
                <InstituteStudentProgressTable data={sampleData.studentProgress} />
              </div>
            </div>
          </div>
        </div>
      </div> */}

      {/* <div className="row mb-4">
        <div className="col-12">
          <InstitutePlacementInsights stats={dashboardData.placementStats} />
        </div>
      </div> */}

      {/* <div className="row mb-4">
        <div className="col-lg-6 mb-4">
          <InstitutePlacementMap stats={dashboardData.placementStats} />
        </div>
        <div className="col-lg-6 mb-4">
          <InstitutePlacementTimeline stats={dashboardData.placementStats} />
        </div>
      </div> */}

      {/* <div className="row mb-4">
        <div className="col-12">
          <div className="card yellowborder rounded-3 hover-lift transition-all">
            <div className="card-header yellow-card-header bg-white border-bottom-0 py-4 d-flex justify-content-between align-items-center">
              <h5 className="mb-0 d-flex align-items-center">
                <i className="bi bi-credit-card-fill me-2 text-primary fs-4"></i>
                <span className="newfont">Recent Transactions</span>
              </h5>
              <button 
                onClick={() => window.location.href = '/institute-credits'}
                className="btn btn-primary btn-sm px-2 py-1 d-flex align-items-center"
              >
                <span>View All</span>
                <i className="bi bi-arrow-right ms-2"></i>
              </button>
            </div>
            <div className="card-body p-4">
              <div className="table-responsive">
                <InstituteTransactionTable transactions={dashboardData.creditTransactions} />
              </div>
            </div>
            <div className="card-footer bg-white border-top-0 py-3">
              <div className="d-flex justify-content-between align-items-center px-3">
                <div className="text-muted">
                  <small><i className="bi bi-info-circle me-1"></i>Showing latest transactions</small>
                </div>
                <div className="text-muted">
                  <small>Updated {new Date().toLocaleDateString()}</small>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> */}
    </>
  );
};

export default InstituteDashboard;